import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "layout-wrapper" }
const _hoisted_2 = { class: "layout-vertical__main-content" }
const _hoisted_3 = { class: "layout-vertical__page-content" }
const _hoisted_4 = { class: "layout-vertical__container-fluid" }

import { computed } from "vue";
import { useRoute } from "vue-router";
import { SideBar } from "@/widgets/SideBar/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'VerticalLayout',
  setup(__props) {

const route = useRoute();
const hideSidebar = computed(() => Boolean(route.meta?.hideSidebar));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout-vertical", { 'layout-vertical_no-sidebar': hideSidebar.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!hideSidebar.value)
        ? (_openBlock(), _createBlock(_unref(SideBar), { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ])
  ], 2))
}
}

})